export default function IconMailReply({ className }: { className?: string }) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path
				d="M18.2785 10.3024C18.3407 9.5878 18.3705 8.80262 18.3705 7.86228C18.3705 6.28791 18.2872 5.14851 18.1072 4.04727C17.9286 2.95546 17.0102 2.15233 15.9109 2.02713C14.0082 1.81043 12.0314 1.64807 9.99993 1.64807C7.96843 1.64807 5.99162 1.81043 4.08895 2.02713C2.98975 2.15233 2.07125 2.95546 1.89275 4.04727C1.7127 5.14851 1.62939 6.28791 1.62939 7.86228C1.62939 9.43665 1.71271 10.5761 1.89275 11.6774C2.07125 12.7692 2.98979 13.5724 4.08901 13.6975L4.25746 13.7166"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.33569 3.00531L8.34276 7.74447C9.31479 8.51133 10.6857 8.51206 11.6586 7.74626L17.6747 3.01055"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M11.6199 14.3527H15.6378C17.117 14.3527 18.3163 15.5519 18.3163 17.0312V18.3705" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M14.2985 11.6741L11.6199 14.3526L14.2985 17.0312" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9.94566 11.6741L7.26709 14.3526L9.94566 17.0312" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
